import React from "react";
import "./footer.css";
import { FaLinkedin, FaGithub, FaEnvelope, FaFileAlt } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-icons">
          <a
            href="https://www.linkedin.com/in/ryliehorning"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedin />
          </a>
          <a
            href="https://github.com/rylieh31"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
          >
            <FaGithub />
          </a>
          <a href="mailto:rylieh@vt.edu" aria-label="Email">
            <FaEnvelope />
          </a>
          <a
            href="/resume"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Resume"
          >
            <FaFileAlt />
          </a>

        </div>
      </div>
    </footer>
  );
};

export default Footer;